<!-- 内部公告 -->
<template>
  <div class="home-pannel" style="height: 100%;">
    <div class="home-pannel-title" style="display:flex;justify-content:space-between;">
      <span>内部公告</span>
      <div class="fontContent" @click="seeMore">查看更多</div>
    </div>
    <div class="noticeList" v-if="noticeList.length" style="height: 82%; overflow-y:scroll;">
      <div class="notice" v-for="item in noticeList" :key="item.id">
        <div class="notice-title" @click="noticeTitle(item)">
          <a-tooltip :title="item.title" placement="topLeft">
            <a-icon type="sound" theme="twoTone" twoToneColor="#1890ff"/>
            <span style="margin: 0px 5px">{{ item.title }}</span>
            <img v-if="timeSetNew(item.createTime)" style="margin: -9px 0px" src="../../../static/img/new.png" alt="">
          </a-tooltip>
        </div>
        <div class="notice-time">
          <span>{{ item.createTime }}</span>
        </div>
      </div>
    </div>
    <div v-if="noticeList.length === 0" style="height: 82%; overflow-y:scroll;">
      <a-empty style="margin-top: 55px"/>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      noticeList: [],
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      }
    }
  },
  beforeMount () {
    this.getNotification()
  },
  methods: {
    getNotification () {
      this.$get('/notice/list', {pageSize: 10, pageNum: 1}).then(res => {
        if (res.status === 200 && res.data.status === 1) {
          this.noticeList = res.data.data.rows
        }
      })
    },
    noticeTitle (item) {
      console.log('11111111111111111')
      this.$emit('noticeTitled', item)
    },
    timeSetNew (time) {
      // 获取当前时间
      var currentTime = new Date()
      // 设置目标时间为7天前
      currentTime.setDate(currentTime.getDate() - 7) // 注意这里加上了1，因为月份从0开始计数
      var currentTime1 = new Date()
      // 当前时间
      currentTime1.setDate(currentTime1.getDate())
      // 创建要比较的时间
      var targetTime = new Date(time) // 将"2023-05-08"改成需要比较的时间字符串
      // 判断两个时间是否相等或者在同一周内（包括今天）
      if (targetTime <= currentTime1 && currentTime < targetTime) {
        return true
      } else {
        return false
      }
    },
    seeMore () {
      // let seeMore = 'seeMore'
      // this.$emit('noticeTitled', seeMore)
      this.$router.push('system/notice1')
    },
    projectChanges (value, name) {
      this.publicDrawer.visible = false
    }
    // noticeTitled (item) {
    //   if (item === 'seeMore') {
    //     this.publicDias.visible = true
    //     this.publicDias.title = '内部公告'
    //     this.publicDias.comName = 'system/notice'
    //   } else {
    //     this.publicDrawer.title = '内部公告'
    //     this.publicDrawer.visible = true
    //     this.publicDrawer.comName = 'system/notice/noticeDraw.vue'
    //     this.$nextTick(() => {
    //       this.$refs.publicDrawerRef.setForm(item)
    //     })
    //   }
    // },
  }
}
</script>

<style lang="less" scoped>
  .noticeList {
    padding: 16px 15px;
    .notice {
      display: flex;
      cursor: pointer;
      justify-content: space-between;
      .notice-title {
        font-size: 14px;
        color: #333333;
        margin-bottom: 10px;
      }
      .notice-content {
        font-size: 12px;
        color: #797979;
      }
    }
  }
  .fontContent{
    cursor: pointer;
    border: 1px solid #e1e1e1;
    height: 30px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    margin-top: 10px;
    margin-right: 10px;
    padding: 0 6px;
    display: flex;
    align-items: center;
  }
    .fontContent:hover{
      background-color: #e9e9e9;
    }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/internalAnnouncement.vue